import styled from 'styled-components';

const Container = styled.div`
  min-height: calc(100vh - 55px); // 55px is the height of the header
  height: 100%;
  padding: ${(props) => (props.active === 'manageTesters' ? '55px 0 40px 245px' : '80px 45px 40px 295px;')};
`;

export {
  Container,
};
